// Common CONSTANT file to avoid duplicates within module
const editableType = {
  NON_EDITABLE: 0,
  EDITABLE: 1,
  INCREMENT_ONLY: 2,
  DECREMENT_ONLY: 3,
};

export default editableType;
